import React, { lazy } from 'react'
import { Route } from 'react-router'
import { SubRouter } from '@/router/SubRouter'

const Index = lazy(() => import('./Index'))
const Detail = lazy(() => import('./Detail'))

//	///////////////////////
//	MARK: EXPORTS
/** ★ Le registre ERP — `03` §3.10. Préfixe statique pour la fiche, les onglets prennent le reste. */
export const SafetyErpRouter = React.memo(() => (
  <SubRouter loggedIn roles={['role--safety--erp']}>
    <Route path='event/:eventId/*' element={<Detail />} />
    <Route path='*' element={<Index />} />
  </SubRouter>
))
